export const metaMixin = {
  methods: {
    updatePageMeta(title, description) {
      // Update page title
      document.title = title + ' | Renedian'
      
      // Update meta description
      const descriptionTag = document.querySelector('meta[name="description"]')
      if (descriptionTag) {
        descriptionTag.setAttribute('content', description)
      }
      
      // Update Open Graph meta tags
      const ogTitleTag = document.querySelector('meta[property="og:title"]')
      if (ogTitleTag) {
        ogTitleTag.setAttribute('content', title + ' | Renedian')
      }
      
      const ogDescriptionTag = document.querySelector('meta[property="og:description"]')
      if (ogDescriptionTag) {
        ogDescriptionTag.setAttribute('content', description)
      }
      
      // Update Twitter meta tags
      const twitterTitleTag = document.querySelector('meta[name="twitter:title"]')
      if (twitterTitleTag) {
        twitterTitleTag.setAttribute('content', title + ' | Renedian')
      }
      
      const twitterDescriptionTag = document.querySelector('meta[name="twitter:description"]')
      if (twitterDescriptionTag) {
        twitterDescriptionTag.setAttribute('content', description)
      }
    }
  }
} 